module.exports = __webpack_public_path__ + "static/media/white.83a4e2cb.svg";